"use strict";

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_chained_error_1 = require("typescript-chained-error");

var SecurityChecker =
/*#__PURE__*/
function () {
  function SecurityChecker() {
    _classCallCheck(this, SecurityChecker);
  }

  _createClass(SecurityChecker, null, [{
    key: "checkSecurity",
    value: function checkSecurity(text, props) {
      if (!props.allowScriptTag && this.containsScriptTag(text)) {
        throw new SecurityChecker.SecurityError("Renderer rejected the input because of insecure content: text contains script tag");
      }
    }
  }, {
    key: "containsScriptTag",
    value: function containsScriptTag(text) {
      return /<\s*script/gi.test(text);
    }
  }]);

  return SecurityChecker;
}();

exports.SecurityChecker = SecurityChecker;

(function (SecurityChecker) {
  /* tslint:disable max-classes-per-file */
  var SecurityError =
  /*#__PURE__*/
  function (_typescript_chained_e) {
    _inherits(SecurityError, _typescript_chained_e);

    function SecurityError(message, cause) {
      _classCallCheck(this, SecurityError);

      return _possibleConstructorReturn(this, _getPrototypeOf(SecurityError).call(this, message, cause));
    }

    return SecurityError;
  }(typescript_chained_error_1.default);

  SecurityChecker.SecurityError = SecurityError;
})(SecurityChecker = exports.SecurityChecker || (exports.SecurityChecker = {}));